<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
    <!--begin::Page title-->
    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading">
          <svg width="38" height="35" viewBox="0 0 38 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_1453_6867)">
              <path
                d="M32.0677 12.4491C31.992 11.4747 31.1894 10.7117 30.2182 10.6796C28.9115 10.6367 27.662 9.92928 26.9805 8.7064C26.2904 7.48059 26.3321 6.03846 26.9679 4.8906C27.4497 4.02046 27.1725 2.93204 26.3631 2.35616C25.7301 1.90598 25.0564 1.5094 24.3488 1.17225C23.4492 0.743512 22.3655 1.03584 21.8469 1.88942C21.1664 3.00902 19.9412 3.75639 18.5366 3.75639C17.132 3.75639 15.9077 3.00902 15.2263 1.88942C14.7067 1.03486 13.624 0.742538 12.7244 1.17225C12.0168 1.5094 11.3441 1.90598 10.7101 2.35616C9.90073 2.93204 9.6235 4.01948 10.1053 4.8906C10.7412 6.03944 10.7828 7.48156 10.0927 8.7064C9.41122 9.92928 8.16173 10.6357 6.85506 10.6796C5.88378 10.7117 5.08116 11.4747 5.00556 12.4491C4.97841 12.796 4.96484 13.1468 4.96484 13.5005C4.96484 13.8542 4.97841 14.205 5.00556 14.5519C5.08116 15.5263 5.88378 16.2893 6.85506 16.3214C8.16173 16.3643 9.41122 17.0707 10.0927 18.2946C10.7828 19.5204 10.7412 20.9625 10.1053 22.1104C9.6235 22.9805 9.90073 24.069 10.7101 24.6448C11.3431 25.095 12.0168 25.4916 12.7244 25.8287C13.624 26.2575 14.7067 25.9652 15.2263 25.1116C15.9068 23.992 17.132 23.2446 18.5366 23.2446C19.9412 23.2446 21.1655 23.991 21.8469 25.1116C22.3665 25.9661 23.4492 26.2585 24.3488 25.8287C25.0564 25.4916 25.7301 25.095 26.3631 24.6448C27.1725 24.069 27.4497 22.9815 26.9679 22.1104C26.3321 20.9616 26.2904 19.5194 26.9805 18.2946C27.662 17.0717 28.9115 16.3653 30.2182 16.3214C31.1894 16.2893 31.992 15.5263 32.0677 14.5519C32.0948 14.205 32.1084 13.8542 32.1084 13.5005C32.1084 13.1468 32.0948 12.796 32.0677 12.4491ZM18.5376 18.3726C15.8612 18.3726 13.6909 16.1908 13.6909 13.5005C13.6909 10.8102 15.8612 8.62845 18.5376 8.62845C21.2139 8.62845 23.3843 10.8102 23.3843 13.5005C23.3843 16.1908 21.2139 18.3726 18.5376 18.3726Z"
                fill="#265D91" />
              <path
                d="M13.5907 27C13.1622 27 12.726 26.9055 12.314 26.7096C11.5628 26.351 10.8368 25.9242 10.1553 25.44C8.92814 24.5679 8.54525 22.9338 9.26256 21.6368C9.7608 20.7384 9.75692 19.6676 9.25384 18.774C8.75559 17.8805 7.85023 17.329 6.82854 17.2949C5.35417 17.2461 4.158 16.0993 4.04362 14.6279C4.01551 14.2547 4 13.8786 4 13.4995C4 13.1205 4.01551 12.7453 4.04362 12.3731C4.158 10.8998 5.35514 9.7539 6.82757 9.70421C7.85023 9.67108 8.75559 9.11956 9.2519 8.22895C9.75692 7.33152 9.75983 6.26161 9.26256 5.36321C8.54525 4.06627 8.92814 2.4312 10.1553 1.56008C10.8358 1.0758 11.5618 0.649007 12.3131 0.291398C13.676 -0.357559 15.2861 0.110158 16.0576 1.38176C16.5908 2.25873 17.5184 2.78199 18.5411 2.78199C19.5638 2.78199 20.4914 2.25873 21.0246 1.38079C21.7971 0.110158 23.4101 -0.357559 24.7682 0.290424C25.5194 0.649007 26.2454 1.0758 26.9269 1.56008C28.1541 2.43218 28.537 4.06627 27.8196 5.36321C27.3214 6.26161 27.3253 7.33249 27.8284 8.22603C28.3266 9.11956 29.232 9.67108 30.2537 9.70518C31.728 9.7539 32.9242 10.9008 33.0386 12.3721C33.0667 12.7453 33.0822 13.1215 33.0822 13.5005C33.0822 13.8796 33.0667 14.2547 33.0386 14.6269C32.9242 16.1002 31.7271 17.2461 30.2546 17.2958C29.232 17.329 28.3266 17.8805 27.8303 18.7711C27.3253 19.6685 27.3224 20.7384 27.8196 21.6368C28.537 22.9338 28.1541 24.5688 26.9269 25.44C26.2464 25.9242 25.5204 26.351 24.7691 26.7087C23.4033 27.3586 21.7962 26.8889 21.0236 25.6193C20.4914 24.7413 19.5638 24.2181 18.5411 24.2181C17.5184 24.2181 16.5908 24.7413 16.0586 25.6183C15.5197 26.503 14.5755 27 13.5907 27ZM13.5907 1.94985C13.4414 1.94985 13.2882 1.98298 13.1428 2.05216C12.4934 2.36202 11.8643 2.7323 11.2739 3.15129C10.8571 3.44752 10.7214 3.99124 10.957 4.41608C11.7858 5.91277 11.7799 7.69595 10.9405 9.1868C10.1243 10.6513 8.57239 11.5985 6.89058 11.653C6.41463 11.6686 6.01332 12.0516 5.97649 12.5251C5.95226 12.8467 5.93868 13.1721 5.93868 13.5005C5.93868 13.8289 5.95226 14.1553 5.97649 14.4778C6.01332 14.9495 6.41463 15.3324 6.89155 15.348C8.57142 15.4035 10.1243 16.3497 10.9424 17.8181C11.779 19.3041 11.7858 21.0873 10.957 22.5849C10.7214 23.0098 10.8571 23.5535 11.2739 23.8497C11.8633 24.2687 12.4934 24.639 13.1438 24.9489C13.6081 25.171 14.151 25.021 14.404 24.6029C15.2909 23.1423 16.837 22.2702 18.5411 22.2702C20.2452 22.2702 21.7913 23.1433 22.6783 24.6039C22.9322 25.0219 23.4731 25.1691 23.9394 24.9489C24.5888 24.639 25.2179 24.2687 25.8083 23.8497C26.2251 23.5535 26.3608 23.0098 26.1252 22.5849C25.2965 21.0882 25.3023 19.3051 26.1417 17.8142C26.9579 16.3497 28.5098 15.4026 30.1916 15.348C30.6676 15.3324 31.0689 14.9495 31.1057 14.4759C31.13 14.1543 31.1435 13.8289 31.1435 13.5005C31.1435 13.1721 31.13 12.8457 31.1057 12.5232C31.0689 12.0516 30.6676 11.6686 30.1907 11.653C28.5108 11.5975 26.9579 10.6513 26.1398 9.1829C25.3032 7.69692 25.2965 5.91375 26.1252 4.41608C26.3608 3.99124 26.2251 3.44752 25.8083 3.15129C25.2189 2.7323 24.5888 2.36202 23.9384 2.05216C23.4741 1.83097 22.9322 1.98005 22.6792 2.3971C21.7913 3.85872 20.2442 4.73081 18.5411 4.73081C16.838 4.73081 15.2909 3.85872 14.403 2.3971C14.2285 2.10965 13.9183 1.94985 13.5907 1.94985Z"
                fill="#265D91" />
            </g>
            <defs>
              <filter id="filter0_d_1453_6867" x="0" y="0" width="37.082" height="35" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1453_6867" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1453_6867" result="shape" />
              </filter>
            </defs>
          </svg>


          Paramètres
        </h1>

        <!--begin::Menu-->

      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a routerLink="/accueil" class="text-muted ">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">Paramètres</li>
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <li class="breadcrumb-item text-muted">Mailing </li>
        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->

    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>

<div id="kt_app_content" class="app-content flex-column-fluid mb-15">
  <div id="kt_app_content_container" class="app-container container-fluid">
    <div class="card">
      <div class="card-body">
        <div class="title mb-3 d-flex justify-content-between">
          <h4>Recherche libre</h4>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="input-group search-libre">
              <span class="input-group-text">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                    fill="#7E7C7C" />
                </svg>
              </span>

              <input type="text" data-kt-customer-table-filter="search" [(ngModel)]="searchElement"
                class="form-control ps-5" placeholder="Rechercher" />

              <div class="tooltip-container tooltip-info">
                <div class="tooltip-trigger">
                  <i class="fa-solid fa-circle-info" style="font-size: 20px"></i>
                </div>
                <div class="tooltip-content">
                  <div class="content">
                    <h4>Opérateur AND :</h4>
                    <p>
                      Utilisez l'opérateur AND pour spécifier que les
                      résultats doivent inclure plusieurs termes.
                    </p>
                    <p>
                      Exemple : software AND engineer renverra des profils
                      qui mentionnent à la fois "software" et "engineer".
                    </p>
                    <h4>Opérateur OR :</h4>
                    <p>
                      Utilisez l'opérateur OR pour spécifier que les
                      résultats peuvent inclure l'un des termes.
                    </p>
                    <p>
                      Exemple : sales OR marketing renverra des profils
                      qui mentionnent soit "sales" soit "marketing".
                    </p>
                    <h4>Opérateur NOT :</h4>
                    <p>
                      Utilisez l'opérateur NOT pour exclure des termes
                      spécifiques des résultats.
                    </p>
                    <p>
                      Exemple : developer NOT manager renverra des profils
                      qui mentionnent "developer" mais pas "manager".
                    </p>
                    <h4>Guillemets pour une expression exacte :</h4>
                    <p>
                      Utilisez des guillemets pour rechercher une
                      expression exacte.
                    </p>
                    <p>
                      Exemple : "product manager" renverra des profils qui
                      mentionnent exactement "product manager".
                    </p>
                    <h4>Parenthèses pour grouper des opérations :</h4>
                    <p>
                      Utilisez des parenthèses pour définir l'ordre
                      d'évaluation des opérations.
                    </p>
                    <p>
                      Exemple : (sales OR marketing) AND manager renverra
                      des profils qui mentionnent "sales" ou "marketing"
                      et "manager".
                    </p>
                    <h4>Recherche standard :</h4>
                    <p>
                      Si aucun opérateur n'est spécifié dans la recherche,
                      le texte sera interprété comme s'il était entre
                      guillemets.
                    </p>
                    <p>
                      Exemple : La recherche product manager sera traitée
                      comme "product manager", suivant la règle 4.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-lg-6">
            <div class="search-btn" style="float: right">
              <div class="mb-3  d-flex justify-content-end">
                <div class="align-items-center recherche">
                  <!-- Bouton Submit -->
                  <button type="submit" class="me-5" (click)="currentPage=0; applyFilter(); startSearching = true">
                    <svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                        fill="white" />
                    </svg>
                    Rechercher
                  </button>
                </div>
                <!-- Bouton Reset -->
                <div class="resett-btn">
                  <div class="reset-icon cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top"
                    title="Réinitialiser">
                    <a (click)="onReset()">
                      <img src="/assets/media/icons/reset.png" alt="" width="30px" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
  <!--begin::Content container-->
  <div id="kt_app_content_container" class="app-container container-fluid">
    <!--begin::Card-->
    <div class="card content-table">
      <!--begin::Card header-->

      <div class="card-body">
        <div class="d-flex flex-wrap my-1 header-grid align-items-center">
          <div class="section_title">
            <h1 class="section-heading my-0">Paramétrage Mailing de contact</h1>
            <div class="recherche ">
              <button type="button" class="btn ajouter" (click)="openModal(add_update_Mailing, 'create_mailing')">+
                Ajouter mail de contact</button>
              <ul class="nav nav-pills me-5" *ngIf="MailingList && MailingList.length">
                <li class="nav-item m-0">
                  <a class="btn btn-sm btn-icon  btn-color-muted btn-active-primary  me-3" data-bs-toggle="tab"
                    href="#kt_project_targets_card_pane">
                    <i class="ki-duotone ki-element-plus fs-1">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                  </a>
                </li>
                <li class="nav-item m-0">
                  <a class="btn btn-sm btn-icon  btn-color-muted btn-active-primary active" data-bs-toggle="tab"
                    href="#kt_project_targets_table_pane">
                    <i class="ki-duotone ki-row-horizontal fs-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <!--begin::Tab nav-->

          <!--end::Tab nav-->
        </div>
        <div >
          <div class="card-body pt-0">
            <div class="tab-content for-web">
              <div id="kt_project_targets_table_pane" class="tab-pane fade show active">
                <div class="content">
                  <div class="pt-3">
                    <div class="table-responsive" id="kt_customers_table" *ngIf="MailingList?.length">
                      <table class="table align-middle fs-6 gy-5 style-table" id="list_cra">
                        <thead>
                          <th class="min-w-125px">
                            <span>Type du contact</span>
                          </th>
                          <th class="min-w-125px">
                            <span>Mail</span>
                          </th>
                          <th class="min-w-125px">
                            <span>Actions</span>
                          </th>
                        </thead>
                        <tbody *ngFor="let Mailing of MailingList">
                          <tr>

                            <td>
                              <span>{{Mailing.contactName}}</span>
                            </td>
                            <td>
                              <span>{{Mailing.contactMail}}</span>

                            </td>
                            <td class="d-flex justify-content-center">
                              <!-- <div class="dropdown">
                                <button mat-button [matMenuTriggerFor]="menu"
                                  class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                  type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                                  aria-expanded="false">
                                  <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="2.44739" cy="2.44739" r="2.44739" transform="matrix(1 0 0 -1 0 4.89478)"
                                      fill="#265D91" />
                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                      transform="matrix(1 0 0 -1 6.85254 4.89478)" fill="#265D91" />
                                    <circle cx="2.44739" cy="2.44739" r="2.44739"
                                      transform="matrix(1 0 0 -1 13.7061 4.89478)" fill="#265D91" />
                                  </svg>
                                </button>
                                <mat-menu #menu="matMenu">
                                  <button mat-menu-item class="dropdown-item"
                                    (click)="openModal(add_update_Mailing,'update_mailing',Mailing)"
                                    style="cursor: pointer;">Modifier</button>
                                  <button mat-menu-item class="dropdown-item" (click)="deleteMailing(Mailing.id)"
                                    style="cursor: pointer;">Supprimer</button>
                                </mat-menu>
                              </div> -->
                              <button type="button  " class="edit" id="edit"
                            (click)="openModal(add_update_Mailing,'update_mailing',Mailing)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"
                              fill="none">
                              <g filter="url(#filter0_d_1938_1307)">
                                <path
                                  d="M4 15.6558V5.59137C4 4.9982 4.23707 4.42933 4.65906 4.00989C5.08106 3.59046 5.6534 3.35482 6.25019 3.35482H13.1301L10.9165 5.59137H6.25019V15.6558H16.376V11.0206L18.6262 8.82039V15.6558C18.6262 16.249 18.3891 16.8179 17.9671 17.2373C17.5451 17.6567 16.9728 17.8924 16.376 17.8924H6.25019C5.6534 17.8924 5.08106 17.6567 4.65906 17.2373C4.23707 16.8179 4 16.249 4 15.6558ZM20.3138 0C19.8664 0.000391512 19.4374 0.177375 19.1212 0.492041L11.1246 8.56878C10.8786 8.8174 10.6929 9.11861 10.5818 9.44942L9.77173 11.8677C9.76161 11.9064 9.76183 11.947 9.77238 11.9855C9.78293 12.0241 9.80343 12.0592 9.83185 12.0875C9.86028 12.1157 9.89564 12.1361 9.93443 12.1466C9.97322 12.1571 10.0141 12.1573 10.053 12.1473L12.4944 11.3505C12.8273 11.2401 13.1304 11.0556 13.3805 10.8109L21.5064 2.86278C21.7422 2.6282 21.9027 2.32944 21.9677 2.00425C22.0326 1.67906 21.9992 1.34202 21.8716 1.03569C21.744 0.729368 21.5279 0.4675 21.2507 0.283164C20.9734 0.098828 20.6474 0.000291618 20.3138 0Z"
                                  fill="#265D91" />
                              </g>
                              <defs>
                                <filter id="filter0_d_1938_1307" x="0" y="0" width="26" height="25.8923"
                                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="4" />
                                  <feGaussianBlur stdDeviation="2" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix"
                                    result="effect1_dropShadow_1938_1307" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1938_1307"
                                    result="shape" />
                                </filter>
                              </defs>
                            </svg>
                          </button>
                          <div class="delete-icon cursor-pointer">
                            <button type="button" (click)="deleteMailing(Mailing.id)" data-bs-target="#add_FAQ" id="delete">
                              <svg data-bs-toggle="modal" width="17" height="19" viewBox="0 0 17 19" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M14.9851 4.17508H15.6809C15.8655 4.17508 16.0425 4.10177 16.173 3.97127C16.3035 3.84078 16.3768 3.66379 16.3768 3.47924C16.3768 3.29469 16.3035 3.11769 16.173 2.9872C16.0425 2.8567 15.8655 2.78339 15.6809 2.78339H12.2017V2.08754C12.2 1.5344 11.9796 1.00438 11.5884 0.613252C11.1973 0.222119 10.6673 0.001652 10.1141 0H5.93906C5.38591 0.001652 4.8559 0.222119 4.46477 0.613252C4.07363 1.00438 3.85317 1.5344 3.85151 2.08754V2.78339H0.695847C0.511297 2.78339 0.334305 2.8567 0.203809 2.9872C0.0733121 3.11769 0 3.29469 0 3.47924C0 3.66379 0.0733121 3.84078 0.203809 3.97127C0.334305 4.10177 0.511297 4.17508 0.695847 4.17508H1.06813V14.6128C1.06813 15.5355 1.43469 16.4205 2.08717 17.073C2.73965 17.7255 3.62461 18.092 4.54736 18.092H11.5058C12.4286 18.092 13.3135 17.7255 13.966 17.073C14.6185 16.4205 14.9851 15.5355 14.9851 14.6128V4.17508ZM6.6349 13.2211C6.6349 13.4056 6.56159 13.5826 6.43109 13.7131C6.3006 13.8436 6.12361 13.9169 5.93906 13.9169C5.75451 13.9169 5.57751 13.8436 5.44702 13.7131C5.31652 13.5826 5.24321 13.4056 5.24321 13.2211V7.65432C5.24321 7.46977 5.31652 7.29278 5.44702 7.16228C5.57751 7.03178 5.75451 6.95847 5.93906 6.95847C6.12361 6.95847 6.3006 7.03178 6.43109 7.16228C6.56159 7.29278 6.6349 7.46977 6.6349 7.65432V13.2211ZM10.81 13.2211C10.81 13.4056 10.7367 13.5826 10.6062 13.7131C10.4757 13.8436 10.2987 13.9169 10.1141 13.9169C9.92959 13.9169 9.7526 13.8436 9.6221 13.7131C9.4916 13.5826 9.41829 13.4056 9.41829 13.2211V7.65432C9.41829 7.46977 9.4916 7.29278 9.6221 7.16228C9.7526 7.03178 9.92959 6.95847 10.1141 6.95847C10.2987 6.95847 10.4757 7.03178 10.6062 7.16228C10.7367 7.29278 10.81 7.46977 10.81 7.65432V13.2211ZM10.81 2.78339H5.24321V2.08754C5.24321 1.90299 5.31652 1.726 5.44702 1.5955C5.57751 1.46501 5.75451 1.39169 5.93906 1.39169H10.1141C10.2987 1.39169 10.4757 1.46501 10.6062 1.5955C10.7367 1.726 10.81 1.90299 10.81 2.08754V2.78339Z"
                                  fill="#EE6352" />
                              </svg>
                            </button>

                          </div>
                              <!--begin::Menu-->
                              
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <app-empty-state *ngIf="MailingList&&!MailingList.length " [title]="parentItem"></app-empty-state>
                      <div class="pagination mt-5 pt-5" *ngIf="MailingList?.length">
                        <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                          [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                          aria-label="Select page">
                        </mat-paginator>
                      </div>
                    </div>
                    <app-empty-state *ngIf="!MailingList?.length" [title]="parentItem"></app-empty-state>
                  </div>
                </div>
              </div>

                  <div id="kt_project_targets_card_pane" class="tab-pane fade" *ngIf="MailingList && MailingList.length">

            <div class="row g-6 g-xl-9 justify-content-center" >
              <!--begin::Col-->
              <div class="col-md-6 col-xxl-4" *ngFor="let Mailing of MailingList">
                <!--begin::Card-->
                <div class="card pt-5 p-5">
                  <div class="card-body d-flex flex-center flex-column">
                    <div class="poste">
                      <span class="job-title mb-5">{{Mailing.contactMail!=="null" ? Mailing.contactMail : '---'}}</span>
                     
                    </div>
                    <div class="content-card mt-5 info">
                     
                      <div class="type mb-3">
                        <span>Type du contact :</span>
                        {{Mailing.contactName!=="null"  ? Mailing.contactName : '---'}}
                      </div>
                    </div>
                  </div>
                  <div class="sep"></div>
                  <div class="foot p-5">
                    <div class="linked">
                      <div class="plus">
                       <button type="button  " class="edit" id="edit"
                            (click)="openModal(add_update_Mailing,'update_mailing',Mailing)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"
                              fill="none">
                              <g filter="url(#filter0_d_1938_1307)">
                                <path
                                  d="M4 15.6558V5.59137C4 4.9982 4.23707 4.42933 4.65906 4.00989C5.08106 3.59046 5.6534 3.35482 6.25019 3.35482H13.1301L10.9165 5.59137H6.25019V15.6558H16.376V11.0206L18.6262 8.82039V15.6558C18.6262 16.249 18.3891 16.8179 17.9671 17.2373C17.5451 17.6567 16.9728 17.8924 16.376 17.8924H6.25019C5.6534 17.8924 5.08106 17.6567 4.65906 17.2373C4.23707 16.8179 4 16.249 4 15.6558ZM20.3138 0C19.8664 0.000391512 19.4374 0.177375 19.1212 0.492041L11.1246 8.56878C10.8786 8.8174 10.6929 9.11861 10.5818 9.44942L9.77173 11.8677C9.76161 11.9064 9.76183 11.947 9.77238 11.9855C9.78293 12.0241 9.80343 12.0592 9.83185 12.0875C9.86028 12.1157 9.89564 12.1361 9.93443 12.1466C9.97322 12.1571 10.0141 12.1573 10.053 12.1473L12.4944 11.3505C12.8273 11.2401 13.1304 11.0556 13.3805 10.8109L21.5064 2.86278C21.7422 2.6282 21.9027 2.32944 21.9677 2.00425C22.0326 1.67906 21.9992 1.34202 21.8716 1.03569C21.744 0.729368 21.5279 0.4675 21.2507 0.283164C20.9734 0.098828 20.6474 0.000291618 20.3138 0Z"
                                  fill="#265D91" />
                              </g>
                              <defs>
                                <filter id="filter0_d_1938_1307" x="0" y="0" width="26" height="25.8923"
                                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="4" />
                                  <feGaussianBlur stdDeviation="2" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix"
                                    result="effect1_dropShadow_1938_1307" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1938_1307"
                                    result="shape" />
                                </filter>
                              </defs>
                            </svg>
                          </button>
                          <div class="delete-icon cursor-pointer">
                            <button type="button" (click)="deleteMailing(Mailing.id)" data-bs-target="#add_FAQ" id="delete">
                              <svg data-bs-toggle="modal" width="17" height="19" viewBox="0 0 17 19" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M14.9851 4.17508H15.6809C15.8655 4.17508 16.0425 4.10177 16.173 3.97127C16.3035 3.84078 16.3768 3.66379 16.3768 3.47924C16.3768 3.29469 16.3035 3.11769 16.173 2.9872C16.0425 2.8567 15.8655 2.78339 15.6809 2.78339H12.2017V2.08754C12.2 1.5344 11.9796 1.00438 11.5884 0.613252C11.1973 0.222119 10.6673 0.001652 10.1141 0H5.93906C5.38591 0.001652 4.8559 0.222119 4.46477 0.613252C4.07363 1.00438 3.85317 1.5344 3.85151 2.08754V2.78339H0.695847C0.511297 2.78339 0.334305 2.8567 0.203809 2.9872C0.0733121 3.11769 0 3.29469 0 3.47924C0 3.66379 0.0733121 3.84078 0.203809 3.97127C0.334305 4.10177 0.511297 4.17508 0.695847 4.17508H1.06813V14.6128C1.06813 15.5355 1.43469 16.4205 2.08717 17.073C2.73965 17.7255 3.62461 18.092 4.54736 18.092H11.5058C12.4286 18.092 13.3135 17.7255 13.966 17.073C14.6185 16.4205 14.9851 15.5355 14.9851 14.6128V4.17508ZM6.6349 13.2211C6.6349 13.4056 6.56159 13.5826 6.43109 13.7131C6.3006 13.8436 6.12361 13.9169 5.93906 13.9169C5.75451 13.9169 5.57751 13.8436 5.44702 13.7131C5.31652 13.5826 5.24321 13.4056 5.24321 13.2211V7.65432C5.24321 7.46977 5.31652 7.29278 5.44702 7.16228C5.57751 7.03178 5.75451 6.95847 5.93906 6.95847C6.12361 6.95847 6.3006 7.03178 6.43109 7.16228C6.56159 7.29278 6.6349 7.46977 6.6349 7.65432V13.2211ZM10.81 13.2211C10.81 13.4056 10.7367 13.5826 10.6062 13.7131C10.4757 13.8436 10.2987 13.9169 10.1141 13.9169C9.92959 13.9169 9.7526 13.8436 9.6221 13.7131C9.4916 13.5826 9.41829 13.4056 9.41829 13.2211V7.65432C9.41829 7.46977 9.4916 7.29278 9.6221 7.16228C9.7526 7.03178 9.92959 6.95847 10.1141 6.95847C10.2987 6.95847 10.4757 7.03178 10.6062 7.16228C10.7367 7.29278 10.81 7.46977 10.81 7.65432V13.2211ZM10.81 2.78339H5.24321V2.08754C5.24321 1.90299 5.31652 1.726 5.44702 1.5955C5.57751 1.46501 5.75451 1.39169 5.93906 1.39169H10.1141C10.2987 1.39169 10.4757 1.46501 10.6062 1.5955C10.7367 1.726 10.81 1.90299 10.81 2.08754V2.78339Z"
                                  fill="#EE6352" />
                              </svg>
                            </button>

                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                aria-label="Select page">
              </mat-paginator>

            </div>
          </div>
            </div>
            <div class="tab-content for-mobile">
              <div id="kt_project_targets_card_pane" class="tab-pane fade show active">
                 <div class="row g-6 g-xl-9 justify-content-center" >
              <!--begin::Col-->
              <div class="col-md-6 col-xxl-4" *ngFor="let Mailing of MailingList">
                <!--begin::Card-->
                <div class="card pt-5 p-5">
                  <div class="card-body d-flex flex-center flex-column">
                    <div class="poste">
                      <span class="job-title mb-5">{{Mailing.contactMail!=="null" ? Mailing.contactMail : '---'}}</span>
                     
                    </div>
                    <div class="content-card mt-5 info">
                     
                      <div class="type mb-3">
                        <span>Type du contact :</span>
                        {{Mailing.contactName!=="null"  ? Mailing.contactName : '---'}}
                      </div>
                    </div>
                  </div>
                  <div class="sep"></div>
                  <div class="foot p-5">
                    <div class="linked">
                      <div class="plus">
                       <button type="button  " class="edit" id="edit"
                            (click)="openModal(add_update_Mailing,'update_mailing',Mailing)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26"
                              fill="none">
                              <g filter="url(#filter0_d_1938_1307)">
                                <path
                                  d="M4 15.6558V5.59137C4 4.9982 4.23707 4.42933 4.65906 4.00989C5.08106 3.59046 5.6534 3.35482 6.25019 3.35482H13.1301L10.9165 5.59137H6.25019V15.6558H16.376V11.0206L18.6262 8.82039V15.6558C18.6262 16.249 18.3891 16.8179 17.9671 17.2373C17.5451 17.6567 16.9728 17.8924 16.376 17.8924H6.25019C5.6534 17.8924 5.08106 17.6567 4.65906 17.2373C4.23707 16.8179 4 16.249 4 15.6558ZM20.3138 0C19.8664 0.000391512 19.4374 0.177375 19.1212 0.492041L11.1246 8.56878C10.8786 8.8174 10.6929 9.11861 10.5818 9.44942L9.77173 11.8677C9.76161 11.9064 9.76183 11.947 9.77238 11.9855C9.78293 12.0241 9.80343 12.0592 9.83185 12.0875C9.86028 12.1157 9.89564 12.1361 9.93443 12.1466C9.97322 12.1571 10.0141 12.1573 10.053 12.1473L12.4944 11.3505C12.8273 11.2401 13.1304 11.0556 13.3805 10.8109L21.5064 2.86278C21.7422 2.6282 21.9027 2.32944 21.9677 2.00425C22.0326 1.67906 21.9992 1.34202 21.8716 1.03569C21.744 0.729368 21.5279 0.4675 21.2507 0.283164C20.9734 0.098828 20.6474 0.000291618 20.3138 0Z"
                                  fill="#265D91" />
                              </g>
                              <defs>
                                <filter id="filter0_d_1938_1307" x="0" y="0" width="26" height="25.8923"
                                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                  <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                  <feOffset dy="4" />
                                  <feGaussianBlur stdDeviation="2" />
                                  <feComposite in2="hardAlpha" operator="out" />
                                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                  <feBlend mode="normal" in2="BackgroundImageFix"
                                    result="effect1_dropShadow_1938_1307" />
                                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1938_1307"
                                    result="shape" />
                                </filter>
                              </defs>
                            </svg>
                          </button>
                          <div class="delete-icon cursor-pointer">
                            <button type="button" (click)="deleteMailing(Mailing.id)" data-bs-target="#add_FAQ" id="delete">
                              <svg data-bs-toggle="modal" width="17" height="19" viewBox="0 0 17 19" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M14.9851 4.17508H15.6809C15.8655 4.17508 16.0425 4.10177 16.173 3.97127C16.3035 3.84078 16.3768 3.66379 16.3768 3.47924C16.3768 3.29469 16.3035 3.11769 16.173 2.9872C16.0425 2.8567 15.8655 2.78339 15.6809 2.78339H12.2017V2.08754C12.2 1.5344 11.9796 1.00438 11.5884 0.613252C11.1973 0.222119 10.6673 0.001652 10.1141 0H5.93906C5.38591 0.001652 4.8559 0.222119 4.46477 0.613252C4.07363 1.00438 3.85317 1.5344 3.85151 2.08754V2.78339H0.695847C0.511297 2.78339 0.334305 2.8567 0.203809 2.9872C0.0733121 3.11769 0 3.29469 0 3.47924C0 3.66379 0.0733121 3.84078 0.203809 3.97127C0.334305 4.10177 0.511297 4.17508 0.695847 4.17508H1.06813V14.6128C1.06813 15.5355 1.43469 16.4205 2.08717 17.073C2.73965 17.7255 3.62461 18.092 4.54736 18.092H11.5058C12.4286 18.092 13.3135 17.7255 13.966 17.073C14.6185 16.4205 14.9851 15.5355 14.9851 14.6128V4.17508ZM6.6349 13.2211C6.6349 13.4056 6.56159 13.5826 6.43109 13.7131C6.3006 13.8436 6.12361 13.9169 5.93906 13.9169C5.75451 13.9169 5.57751 13.8436 5.44702 13.7131C5.31652 13.5826 5.24321 13.4056 5.24321 13.2211V7.65432C5.24321 7.46977 5.31652 7.29278 5.44702 7.16228C5.57751 7.03178 5.75451 6.95847 5.93906 6.95847C6.12361 6.95847 6.3006 7.03178 6.43109 7.16228C6.56159 7.29278 6.6349 7.46977 6.6349 7.65432V13.2211ZM10.81 13.2211C10.81 13.4056 10.7367 13.5826 10.6062 13.7131C10.4757 13.8436 10.2987 13.9169 10.1141 13.9169C9.92959 13.9169 9.7526 13.8436 9.6221 13.7131C9.4916 13.5826 9.41829 13.4056 9.41829 13.2211V7.65432C9.41829 7.46977 9.4916 7.29278 9.6221 7.16228C9.7526 7.03178 9.92959 6.95847 10.1141 6.95847C10.2987 6.95847 10.4757 7.03178 10.6062 7.16228C10.7367 7.29278 10.81 7.46977 10.81 7.65432V13.2211ZM10.81 2.78339H5.24321V2.08754C5.24321 1.90299 5.31652 1.726 5.44702 1.5955C5.57751 1.46501 5.75451 1.39169 5.93906 1.39169H10.1141C10.2987 1.39169 10.4757 1.46501 10.6062 1.5955C10.7367 1.726 10.81 1.90299 10.81 2.08754V2.78339Z"
                                  fill="#EE6352" />
                              </svg>
                            </button>

                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <mat-paginator [length]="totalItems" [pageSize]="pageSize" [showFirstLastButtons]="true"
                [pageSizeOptions]="pageSizeOptions" [pageIndex]="currentPage" (page)="onPageChange($event)"
                aria-label="Select page">
              </mat-paginator>

            </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!--end::Content container-->
</div>

<ng-template #add_update_Mailing>
  <!--begin::Modal content-->
  <div class="modal-content pt-5  pb-5" [formGroup]="mailingForm">
    <!--begin::Modal header-->
    <div class="modal-header">
      <!--begin::Modal title-->
      <h2 class="fw-bold">{{mode=='create_mailing'?'Ajouter ':'Modifier '}} Mailing</h2>
      <!--end::Modal title-->
      <!--begin::Close-->
      <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary" data-dismiss="modal"
        (click)="closeModal()">
        <i class="ki-duotone ki-cross fs-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
      <!--end::Close-->
    </div>
    <!--end::Modal header-->
    <!--begin::Modal body-->
    <div class="modal-body mx-5 my-7">
      <!--begin::Form-->
      <div class="mb-10">
        <label for="type_activity">Employé</label>
        <ng-select [items]="EmployeesList" bindLabel="full_user_name" [notFoundText]="'Aucun élément trouvé'"
          class="form-select  mb-3" bindValue="uuid" formControlName="employee_id" id="competences"
          placeholder="liste des employées" (change)="onEmployeeSelected($event)">
        </ng-select>
      </div>
      <div class="mb-10">
        <label for="type_activity">Type du contact</label>
        <input type="text" placeholder="Nom du type d’activité" formControlName="contactName" class="form-control mb-3">
      </div>
      <div class="mb-10 tools">
        <label for="role">Mail associé</label>
        <input type="email" name="mail" id="mail" [readonly]="true" class="form-control disabled" formControlName="contactMail"
          placeholder="exemple@gmail.com">
        <app-feild-error [controlName]="'email'" [control]="mailingForm.get('contactMail')">
        </app-feild-error>
      </div>
      <!-- <div class="mb-10" *ngIf="companyType==2">
                        <label for="role">Mail associé</label>
                    <input type="email" name="mail" id="mail" class="form-control" formControlName="emailProESN" placeholder="exemple@gmail.com">
                    <app-feild-error [controlName]="'email'" [control]="mailingForm.get('emailProESN')">
                    </app-feild-error>
                </div> -->

    </div>
    <div class="modal-footer mx-5">
      <div class="actions">
        <button class="annuler" (click)="closeModal()">Annuler</button>
        <button class="confirmer" (click)="confirmer()" [disabled]="!mailingForm.valid">Confirmer</button>
      </div>
    </div>
    <!--end::Modal body-->
  </div>
  <!--end::Modal content-->
</ng-template>
<ngx-spinner class="custom-spinner" bdColor="rgba(255,255,255,1)" size="medium" color="#fff" type="ball-atom"
  [fullScreen]="true">
  <span class="loader">
    <img width="150px" src="/assets/media/logos/logo-wegestu-color.png" alt="">
  </span>
</ngx-spinner>